import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2703a140&scoped=true&"
import script from "./Modal.script.js?vue&type=script&lang=js&"
export * from "./Modal.script.js?vue&type=script&lang=js&"
import style0 from "./Modal.scss?vue&type=style&index=0&id=2703a140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703a140",
  null
  
)

export default component.exports